<template>
  <div id="news">
    <div :class="['banner',{banner2: $route.query.type == 'enterprise',banner1: $route.query.type != 'enterprise'}]"></div>
    <ul class="list">
      <li v-for="(ele,index) in newListall" :key="index" :class="{no_margin: index % 3 == 0}" v-if="index < 6 || index>=6 && ismore"
        @click="opennews(ele.jumpLink)">
        <div class="img">
          <img :src="ele.imgUrl" alt="">
        </div>
        <h1>{{ele.title}}</h1>
        <p>{{ele.newsContent}}</p>
        <span>{{ele.createTime.substring(0,10)}}</span>
      </li>
    </ul>
    <div class="btn" @click="ismore = true" v-if="!ismore">查看更多新闻</div>
    <div style="margin-top:100px;"></div>
    <footerbom></footerbom>
  </div>
</template>

<script type="text/javascript">
import qs from "qs";
export default {
  data() {
    return {
      activeIndex: 0,
      ismore: false,
      // list1: [
      //   {
      //     alink:
      //       "http://mp.weixin.qq.com/s?__biz=MzU5Mjg0MzA2NQ==&mid=100006882&idx=1&sn=e2e08e44598475e3a7da42c854c86e3c&chksm=7e18c3b4496f4aa29fff65a3824b2519083d8bb20108f5eb6e601fd8a3e2c194813a2ece34ff#rd",
      //     title: "合力精耕，共创巨掌美好明天——巨掌数据尾牙晚宴完美收官",
      //     date: "2021-01-18",
      //     cont:
      //       "在2021年1月8日，巨掌数据的伙伴们来到2020年公司尾牙晚宴现场。大家齐聚一堂，满怀喜悦迎接了一场“团圆”相聚，一起度过了一个难忘的时刻。过去的一年是值得让我们大家回味的一年，2020年我们经历了很多坎坷，经历了很多风雨，但是在全体员工的共同努力之下，我们迎来了阳光迎来了鲜花，迎来了掌声。",
      //     img: require("./n1_18.jpg"),
      //   },
      //   {
      //     img: require("./n1_131.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/TpepifxunuOAJdZH-i9mkA",
      //     title: "风云再起，冠军诞生！巨掌第三届王者荣耀比赛完美收官",
      //     date: "2020-11-23",
      //     cont:
      //       "6月30日下午，随着最后一场比赛的结束，掌上王者——第三届王者荣耀战队赛正式落下帷幕。",
      //   },
      //   {
      //     img: require("./n1_132.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/PtBgfCLNyAw8lT9ET_vJHw",
      //     title: "2020巨掌羽毛球篮球赛，舞动精彩，闪耀未来！",
      //     date: "2020-11-26",
      //     cont: "庚子年间，疫情之后，唯有满面笑容才是对生活最好的祝福。",
      //   },
      //   {
      //     img: require("./n11-13.png"),
      //     alink: "https://mp.weixin.qq.com/s/gxNtov2oQDTqlDS6P5S54A",
      //     title: "好消息！巨掌ASA海外优化团队全员通过苹果认证！",
      //     date: "2020-08-24",
      //     cont:
      //       "8月19日-21日，巨掌数据ASA海外优化团队9名优化师参加苹果Apple Search Ads认证考试，最终9人全部成为苹果官方认证Apple Search Ads（ASA）代理优化师。喜讯传来，表明巨掌数据的人才力量、技术实力更加强大",
      //   },
      //   {
      //     img: require("./n1_1.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/-cU_5pGfEq4_Pe0h-ggQLQ",
      //     title: "燃爆了!【掌上王者】王者荣耀战队赛收官，冠军登顶宝座！",
      //     date: "2020-06-30",
      //     cont:
      //       "庚子年间，疫情之后，唯有满面笑容才是对生活最好的祝福。6月30日下午，随着最后一场比赛的结束，掌上王者——巨掌首届王者荣耀战队赛正式落下帷幕。",
      //   },
      //   {
      //     img: require("./n1_2.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/nvC2h_2v5VBPqTv6apGMDw",
      //     title: "重磅！苹果竞价广告ASA即将新登录俄罗斯，巨掌数据同步更新！",
      //     date: "2020-04-07",
      //     cont:
      //       "巨掌第一时间和苹果专家们进行相关情况的沟通，得到的消息是，4月底可搭建俄罗斯账户，预计5月初苹果ASA在俄罗斯开始进行投放。巨掌数据后台也将同步进行更新，App开发商可第一时间在巨掌数据平台搭建账户和投放。",
      //   },
      //   {
      //     img: require("./n1_133.jpg"),
      //     alink: "http://it.people.com.cn/n1/2020/0110/c1009-31543884.html",
      //     title: "首届移动互联网应用安全发展峰会在京举行",
      //     date: "2020-01-10",
      //     cont:
      //       "人民网北京1月10日电 （丁亦鑫）1月10日，由公安部网络安全保卫局指导、人民网和中国信息通信研究院联合主办、巨掌互动科技协办的首届移动互联网应用安全发展峰会在人民日报社新媒体大厦举行。",
      //   },
      //   {
      //     img: require("./n1_3.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/JenySHd1_CMyTEUZ2Cr03A",
      //     title:
      //       "《颠覆重塑 · 2019巨掌效果营销线下干货私享会 》广州站圆满落幕！",
      //     date: "2019-08-27",
      //     cont:
      //       "8月27日，由巨掌数据主办，热云数据协办的《颠覆重塑 · 2019巨掌效果营销线下干货私享会  <广州站>》 圆满举行。巨掌数据COO侯洪文先生和高级运营总监和卓祺女士、运营总监周通先生出席，并邀请阿纳海姆创始人老陈、热云数据商务总监黄磊先生作为嘉宾发表演讲，畅谈移动应用行业的变革动态和前沿技术方法，与100多位到场行业人士一同交流探讨。",
      //   },
      //   {
      //     img: require("./n1_4.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/x_bZH-Qngu1bxC4ML8ZGZg",
      //     title:
      //       "巨掌数据新品发布：只为帮助广告主高效制定投放策略和进行广告投放",
      //     date: "2019-08-05",
      //     cont:
      //       "2019年8月3日，巨掌发布新一代巨掌数据平台（asoasm.com），利用AI技术专注“数据+效果”，只为帮助广告主高效制定投放策略和高效进行广告投放。",
      //   },
      //   {
      //     img: require("./n1_5.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/-pge7X8JLAi4leaU-HBQjw",
      //     title: "6000字珍藏私货：大佬关于未来效果营销模式的深度碰撞！速看！",
      //     date: "2019-08-14",
      //     cont:
      //       "8月3日，巨掌品牌战略升级发布会＆新品发布在上海隆重举行。发布会上，巨掌数据非常荣幸邀请到Talking Data华东开发者总经理刘松先生、诸葛ioCEO孔淼先生、iADBrain CEO罗峰先生、Plug and Play Capital创始合伙人闻凯先生一起探讨数据+AI对效果营销带来怎样的新机遇和新挑战，以下是圆桌论坛的实录：",
      //   },
      //   {
      //     img: require("./n1_6.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/ZbNgIkmypNhHljXzFWNddA",
      //     title:
      //       "巨掌品牌战略升级：专注“数据+效果​”，让数据更懂你，让推广更简单",
      //     date: " 2019-08-03",
      //     cont:
      //       "2019年8月3日，主题为“向新不止，向阳而升”的巨掌品牌战略升级发布会＆新品发布在上海盛大召开。",
      //   },
      //   {
      //     img: require("./n1_7.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/FfVRem0o6Sib7-9Bs1PYjQ",
      //     title:
      //       "《颠覆重塑 · 2019巨掌效果营销线下干货私享会 》北京站圆满落幕！",
      //     date: "2019-07-05",
      //     cont:
      //       "7月5日，巨掌广告《颠覆重塑 · 2019巨掌效果营销线下干货私享会  <北京站>》 在万达文华酒店圆满举行。巨掌广告COO侯洪文和运营总监周通、运营VP李付春、运营副总监吴坚出席，并邀请同程艺龙市场营销总监江颖作为嘉宾发表演讲，畅谈移动应用用户增长方法和趋势，与100多位到场行业人士一同交流探讨。",
      //   },
      //   {
      //     img: require("./n1_8.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/1rkaqw4vvXgbfKihrxQXGQ",
      //     title: "差距啊！吃喝玩乐...瞧瞧别人家公司的61福利！",
      //     date: "2019-05-31",
      //     cont:
      //       "嗯，之前520的时候， 你们哭着喊着要过六一因为宝宝还小，宝宝还年轻",
      //   },
      //   {
      //     img: require("./n1_9.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/_EZaxeE64e8Fyt-S3fRI3w",
      //     title: "巨掌广告五周年庆典活动 | 巨掌进击，所向披靡！",
      //     date: "2019-04-18",
      //     cont:
      //       "2014年8月8日怀揣着梦想 巨掌广告正式成立。一位位端坐在计算机前忙碌的员工，那时的他们还不知道，今后将书写怎样的传奇。讨论再讨论，研究再研究。面对全新的领域，年轻的巨掌人丝毫不敢掉以轻心，匠人的精神那时起便生根发芽。",
      //   },
      //   {
      //     img: require("./n1_10.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/AZ3wzZTd7JSGgt2kjGOqRQ",
      //     title:
      //       "好消息！巨掌广告抢先上线港澳台ASM数据查询，助力广告主挖掘流量红利",
      //     date: "2019-04-15",
      //     cont:
      //       "2019年3月27日苹果宣布Search Ads（App Store搜索竞价广告，下文简称ASM）新增46个国家和地区，加上之前的13国，现在ASM广告已经在59个国家和地区开放。巨掌广告做为全球移动效果营销制定者，在第一时间对旗下ASMaster后台进行升级，包括港澳台在内的新增46个国家和地区当天即可进行投放，助力移动应用出海。",
      //   },
      // ],
      // list2: [
      //   {
      //     img: require("./n11-134.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/7BSPvuX1ggiW92OIvsOnXQ",
      //     title: "打通手机电脑软件，苹果推出划时代芯片，今天的发布会将永载史册",
      //     date: "2020-11-11",
      //     cont:
      //       "苹果今年的三场秋季发布会可谓场场精彩，而最具划时代意义的不是iPhone12的发布，而是今天凌晨的这场发布会，原因为何，让小哥给您细细道来。",
      //   },
      //   {
      //     img: require("./n11-133.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/UK3l_o5ZPlpMveJbgB8K4A",
      //     title: "重要！苹果隐私标签新规12月8日上线，开发者务必引起重视",
      //     date: "2020-11-09",
      //     cont:
      //       "近日，苹果宣布了其隐私标签新规将在12月8日开始实施。苹果在6月的WWDC20上分享了针对iOS 14的隐私和安全更新的消息，规定范围包括App Store和Safari Web浏览器。WWDC20之后，苹果在其开发人员论坛上提供了有关应用程序隐私问题的详细信息。",
      //   },
      //   {
      //     img: require("./n11-132.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/PNbIMmjNupy9T8cLqO4lIQ",
      //     title: "突发！韩国提案强制应用上架全部应用商店，出海韩国要谨慎了",
      //     date: "2020-10-22",
      //     cont:
      //       "今年9月16日，韩国共同民主党议员韩俊镐等27名议员提交了《电子通信事业法部分修订法律案》（下称修订案）。相关修订案以“打破目前应用市场被垄断化的现状，营造公平的竞争环境”为名分，向开发者提出了强制性要求，影响颇大。",
      //   },
      //   {
      //     img: require("./n11-131.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/y2Jk9SCAOxu_iWBI66Fe3g",
      //     title: "重磅！苹果修改App Store审核指南，利好开发者！",
      //     date: "2020-09-14",
      //     cont:
      //       "最近几周，Apple Store的相关规则受到了应用程序开发商的严厉反对，原因是他们认为苹果对iPhone上运行的软件拥有太多控制权。而上周五，苹果在最新版iPhone操作系统iOS 14发布之前，修改了App Store审核指南相关规定。",
      //   },
      //   {
      //     img: require("./n2_1.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/Ntxpcdb2FEsEE0X-M0y6Bw",
      //     title:
      //       "疫情影响下哪些App吸金最多、下载最多？2020年上半年App排行揭晓！",
      //     date: "2020-07-02",
      //     cont:
      //       "由于新冠疫情在全球的爆发，2020年上半年世界各国、各地区的民众都隔离在家。正是因为这种防疫措施，许多应用趁势崛起。近日，国外移动应用数据分析机构也揭晓上半年吸金最多、下载量最多的App有哪些。",
      //   },
      //   {
      //     img: require("./n2_2.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/XgQl9GVzXH6RdTx8IQNVNA",
      //     title: "太难了！5月下架7万App，东北互联网行业收入又双叒叕下降！",
      //     date: "2020-06-30",
      //     cont:
      //       "工信部近日发布了《2020年1－5月互联网和相关服务业运行情况》，我国互联网和相关服务业利润连续两个月保持正增长，移动应用程序（App）整体数量数量也稳步回升。",
      //   },
      //   {
      //     img: require("./n2_3.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/ozUYWAd4fCS3OWDm-H8X-w",
      //     title:
      //       "开发者福音！苹果推应用内购买通知系统：让开发者知道客户何时申请退款",
      //     date: "2020-06-28",
      //     cont:
      //       "苹果公司正在推出一个新的应用内购买服务器通知系统，当客户请求并收到应用内购买的退款时，可以让开发者知道，允许开发者采取适当的行动，比如撤销已购买的商品",
      //   },
      //   {
      //     img: require("./n2_4.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/xy8mPRjHCzoe5us2AbEqoA",
      //     title: "泄密内容最多的一届全球开发者大会，苹果WWDC20发布会重点整理",
      //     date: "2020-06-23",
      //     cont:
      //       "北京时间6月23日凌晨1点，苹果2020年全球开发者大会（WWDC20）正式举行，全球数千万观众通过网络直播观看主题演讲。",
      //   },
      //   {
      //     img: require("./n2_5.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/FWqLtvlW837VsCIZQZVS0g",
      //     title:
      //       "苹果首次公布：App Store年收入5190亿美元，中国超美国成第一市场",
      //     date: "2020-06-16",
      //     cont:
      //       "苹果公司披露，公司委托第三方进行的一项调查研究显示，2019年消费者和广告主通过App Store花费金额达5190亿美元。这是个比之前报道范围更广的数字，因为它包括应用商店促进的所有交易产生的收入，而不仅仅是苹果收取佣金的交易。",
      //   },
      //   {
      //     img: require("./n2_6.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/h-pSH1uyk_MZ9579ZjoeQg",
      //     title: "中国新闻平台三强争霸，数据显示iPhone用户更爱腾讯、新浪新闻",
      //     date: "2020-06-11",
      //     cont:
      //       "近日，Trustdata发布了《中国移动互联网新闻资讯行业发展分析报告》（以下简称报告），分析了2016年1月到2020年3月，中国移动互联网新闻资讯行业用户平台类新闻资讯产品的使用情况。",
      //   },
      //   {
      //     img: require("./n2_7.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/lRgbcsxiieZwJorsBXXqTQ",
      //     title:
      //       "“山寨”App大撒红包，勇夺App Store总榜第一！网友：这套路真熟悉！",
      //     date: "2020-06-08",
      //     cont:
      //       "抖音的国际版本TikTok在海外可谓是大火，4月全球下载量更是突破20亿次。但，就是这样一款现象级应用却在5月末被一款同样是短视频的App拽下了神坛。",
      //   },
      //   {
      //     img: require("./n2_8.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/wbXULx4swv0s_d55UP2YYw",
      //     title: "真的活下来了！4月上架19万App，行业利润终止下滑！",
      //     date: "2020-06-01",
      //     cont:
      //       "工信部今天发布了《2020年1－4月互联网和相关服务业运行情况》，我国互联网和相关服务业利润扭转下滑局面，移动应用程序（App）整体数量也小幅回升。",
      //   },
      //   {
      //     img: require("./n2_9.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/rchgS8TeQ0L_RtGN6zfABw",
      //     title: "大乱斗！快手、抖音互相起诉对方？事情真相原来是这样！",
      //     date: "2020-05-13",
      //     cont:
      //       "这两天的瓜有点儿大，怕是目前圈子里最大新闻了。5月12日，海淀法院披露，“快手”把“抖音”给告了，并且索赔500万。",
      //   },
      //   {
      //     img: require("./n2_10.jpg"),
      //     alink: "https://mp.weixin.qq.com/s/VLKo8PPfYGAZNEUyCjqRdA",
      //     title: "2020年专项治理！App违法违规收集使用个人信息将严查",
      //     date: "2020-04-24",
      //     cont:
      //       "鉴于不少App存在侵害用户隐私、权限滥用等诸多问题，2019年伊始，工信部、网信办、公安部、市场监管总局四部门联合发布了《关于开展App违法违规收集使用个人信息专项治理的公告》。",
      //   },
      // ],
      list: [],
      newListall: []
    };
  },
  computed: {},
  components: {},
  created() {
    this.GetNewsInfoList()
  },
  destroyed() { },
  mounted() {
  },
  methods: {
    opennews(alink) {
      window.open(alink);
    },
    /**获取列表 */
    GetNewsInfoList() {
      let url = "https://api.appasa.com/api/Tool/GetNewsInfoList";
      this.$https.get(url).then((res) => {
        if (this.$route.query.type == 'enterprise') {
          res.data.map(ele => {
            if (ele.tagsName.indexOf('企业动态') != -1) {
              this.newListall.push(ele)
            }
          })
        } else {
          res.data.map(ele => {
            if (ele.tagsName.indexOf('企业动态') == -1) {
              this.newListall.push(ele)
            }
          })
        }
      });
    },
  },

};
</script>

<style lang="less" scoped>
#news {
  width: 100%;
  .banner {
    width: 100%;
    height: 420px;
    &.banner1 {
      background: url("./news_banner1.jpg") no-repeat center center;
      background-size: cover;
    }
    &.banner2 {
      background: url("./news_banner2.jpg") no-repeat center center;
      background-size: cover;
    }
  }
  .btnlist {
    margin: 90px 0;
    display: flex;
    justify-content: center;
    div {
      margin: 0 15px;
      width: 148px;
      height: 50px;
      border-radius: 50px;
      font-size: 20px;
      color: #333;
      cursor: pointer;
      text-align: center;
      line-height: 50px;
      background: #f6f6f6;
      transition: all 0.2s;
      &:hover {
        background: #409eff;
        color: #fff;
        box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
      }
      &.active {
        background: #409eff;
        color: #fff;
        box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
      }
    }
  }
  .list {
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
    margin: 40px auto;
    li {
      width: 30%;
      margin-left: 5%;
      max-height: 480px;
      box-shadow: 0 2px 5px 0 #efeeee;
      box-sizing: border-box;
      padding: 36px 28px 50px;
      border-radius: 10px;
      position: relative;
      transition: all 0.3s ease;
      margin-bottom: 68px;
      cursor: pointer;
      &.no_margin {
        margin-left: 0;
      }
      &:hover {
        transform: translateY(-10px);
        img {
          transform: scale(1.2);
        }
      }
      .img {
        width: 100%;
        max-height: 190px;
        overflow: hidden;
        img {
          transition: all 1s ease;
          width: 100%;
        }
      }
      h1 {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 18px;
        color: #333;
        margin: 30px 0;
        letter-spacing: 2px;
      }
      p {
        font-size: 14px;
        color: #666;
        line-height: 20px;
        letter-spacing: 1px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
      }
      span {
        position: absolute;
        left: 28px;
        bottom: 20px;
        font-size: 14px;
        color: #999;
      }
    }
  }
  .btn {
    width: 200px;
    height: 60px;
    border-radius: 60px;
    background: #409eff;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 60px;
    margin: 10px auto 0;
    font-size: 16px;
    transition: all 0.2s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 2px 5px 0 #efeeee;
      background: #0890f3;
    }
  }
}
</style>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/page/news/index.vue